import {LitElement, html} from 'lit';
import {property, customElement} from 'lit/decorators.js';
import {Service} from '../../service/service.js';
import {UnitService} from '../../service/unit/unitService.js';
import {ElementUtil} from '../../utils/elementUtil.js';
import {TimeUtil} from '../../utils/timeUtil.js';
import {StringUtil} from '../../utils/stringUtil.js';
import {ImportUtil} from '../../utils/importUtil.js';
import {attachWorkspaceFilterState} from '../../utils/workspaceStateUtil.js';
import {BaseComponent} from '../basecomponent.js';
import {UnitTools} from './unitTools.js';
import {TractorTools} from './tractorTools.js';


/* global customElements */
class TractorGrid extends BaseComponent {
	
	static get properties() {
		return {			
		};
	}
	
	constructor() {
		super();
		
		var tractorGrid = this;
		setTimeout(function(){
			tractorGrid.init();
		});
	}
	
	render() {	
		return html`
			<slot></slot>		
		`;
	}
	
	init() {
		var tractorGrid = this;
		
		var toolbarFilter = ElementUtil.create({
			tag: 'dl-toolbar',
		'collapse-label': 'Filter',
			slot: 'toolbar',
			theme: 'spacing',			
			children: [				
				{										
					tag: 'vaadin-combo-box',
					itemid: 'filterType',
					'class': 'spacer-toolbar-item',
					'keep-open': true,					
					style: 'width: 250px;',
					label: 'Filter By',
					'item-value-path': 'code',
					'item-label-path': 'description',
					required: true,
					value: 'tractorRefNo',
					postinit: function(combo) {						
						var lookups = [
							{
								code: 'tractorId',
								description: 'Tractor Id'								
							},
							{
								code: 'tractorVinNo',
								description: 'Vin'	
							},
							{
								code: 'comment',
								description: 'Comment'	
							},
							{
								code: 'tractorRefNo',
								description: 'Reference No'	
							},							
							{
								code: 'tags',
								description: 'Tag'	
							}
						];
						combo.items = lookups;						
					},
					placeHolder: 'Select'					
				},				
				{
					tag: 'vaadin-text-field',
					itemid: 'filterValue',
					'class': 'spacer-toolbar-item',
					'keep-open': true,
					label: 'Filter Value',
					listeners: {
						input: {
							fn: function() {
								actionRefresh();
							},
							buffer: 2000
					    }
					}
				},
				{	
					tag: 'vaadin-combo-box',
					itemid: 'status',						
					'class': 'spacer-toolbar-item',
					'item-value-path': 'code',
					'item-label-path': 'desc',
					'prevent-invalid-input': true,
					postinit: function(combo) {							
						combo.items = [
							{
								code: 'A',
								desc: 'Active'
							}, {
								code: 'I',
								desc: 'Inactive'
							}
						];
						combo.value = 'A';
					},
					listeners: {
						'selected-item-changed': function(event) {
							if (actionRefresh){
								actionRefresh();
							}
						}
					}					
				}				
			]
		});		
		
		var toolbar = ElementUtil.create({
			tag: 'dl-toolbar',
			slot: 'toolbar',
			theme: 'spacing',
			children: [
				{
					tag: 'vaadin-button',
					itemid: 'refresh',
					'class': 'spacer-toolbar-item',
					children:[
						ElementUtil.makeIcon('vaadin:refresh', ' Refresh')
					], 
					listeners: {
						click: function() {
							actionRefresh();
						}
					}
				},
				{
					tag: 'span',
					innerHTML: '|'
				},
				{
					tag: 'dl-action-button',
					itemid: 'add',
					theme: 'primary',
					'class': 'spacer-toolbar-item',					
					permissions: ['TRACTOR_MANAGEMENT:WRITE'],
					children:[
						ElementUtil.makeIcon('vaadin:plus', ' Add')						
					],
					listeners: {
						click: function() {
							actionAddEdit();
						}
					}					
				},
				{
					tag: 'dl-action-button',
					itemid: 'edit',
					'class': 'spacer-toolbar-item',
					disabled: true,	
					permissions: ['TRACTOR_MANAGEMENT:WRITE'],
					children:[
						ElementUtil.makeIcon('vaadin:edit', ' Edit')						
					],
					listeners: {
						click: function() {
							actionAddEdit(grid.selectedItems[0]);
						}
					}					
				},
				{
					tag: 'span',
					innerHTML: '|'
				},
				{
					tag: 'dl-action-button',
					itemid: 'details',
					'class': 'spacer-toolbar-item',
					disabled: true,	
					permissions: ['TRACTOR_MANAGEMENT:READ'],
					children:[
						ElementUtil.makeIcon('vaadin:folder-open', ' Details')						
					],
					listeners: {
						click: function() {
							actionDetails(grid.selectedItems[0]);
						}
					}					
				},
				{
					tag: 'dl-action-button',
					itemid: 'tools',
					'class': 'spacer-toolbar-item',
					disabled: true,
					children:[
						ElementUtil.makeIcon('vaadin:cog', ' Tools')						
					],
					properties: {
						menu: [
							{
								tag: 'dl-action-menu-item',
								itemId: 'history',							
								permissions: ['TRACTOR_MANAGEMENT:WRITE'],							
								trustedInnerHTML: true,
								innerHTML: '<vaadin-icon icon="vaadin:clock"></vaadin-icon> History',
								listeners: {
									click: function(event) {
										actionHistory(grid.selectedItems[0]);
									}
								}
							},
							{
								tag: 'hr'
							},
							{
								tag: 'dl-action-menu-item',
								itemId: 'references',							
								permissions: ['TRACTOR_MANAGEMENT:WRITE'],							
								trustedInnerHTML: true,
								innerHTML: '<vaadin-icon icon="vaadin:chevron-circle-right"></vaadin-icon> References',
								listeners: {
									click: function(event) {
										actionMultiRefs(grid.selectedItems[0]);
									}
								}
							},
							{
								tag: 'dl-action-menu-item',
								itemId: 'juris',
								permissions: ['TRACTOR_MANAGEMENT:WRITE'],							
								trustedInnerHTML: true,
								innerHTML: '<vaadin-icon icon="vaadin:globe" style="color: #189fff"></vaadin-icon> Jurisdicitions',
								listeners: {
									click: function(event) {
										actionJurisdicitions(grid.selectedItems[0]);
									}
								}
							},
							{
								tag: 'dl-action-menu-item',
								itemId: 'ooa',
								permissions: ['TRACTOR_MANAGEMENT:WRITE'],															
								trustedInnerHTML: true,
								innerHTML: '<vaadin-icon icon="vaadin:flag" style="color: red"></vaadin-icon> Out-of-Authority',
								listeners: {
									click: function(event) {
										actionOutOfAuthority(grid.selectedItems[0]);	
									}
								}
							},	
							{
								tag: 'dl-action-menu-item',
								itemId: 'mpgoverride',
								permissions: ['TRACTOR_MANAGEMENT:WRITE'],								
								trustedInnerHTML: true,
								innerHTML: '<vaadin-icon icon="vaadin:truck"></vaadin-icon> MPG Overrides',
								listeners: {
									click: function(event) {
										actionMPGOverride(grid.selectedItems[0]);	
									}
								}
							},
							{
								tag: 'hr'
							},							
							{
								tag: 'dl-action-menu-item',
								itemId: 'toggleStatus',							
								permissions: ['TRACTOR_MANAGEMENT:UPDATE_STATUS'],							
								trustedInnerHTML: true,
								innerHTML: '<vaadin-icon icon="vaadin:check" style="color: green"></vaadin-icon> Toogle Status',
								listeners: {
									click: function(event) {
										actionUpdateStatus(grid.selectedItems);
									}
								}
							},
							{
								tag: 'dl-action-menu-item',
								itemId: 'quickFlag',							
								permissions: ['TRACTOR_MANAGEMENT:UPDATE_STATUS'],							
								trustedInnerHTML: true,
								innerHTML: '<vaadin-icon icon="vaadin:flag" style="color: green"></vaadin-icon> Quick Flag',
								listeners: {
									click: function(event) {
										actionQuickFlag(grid.selectedItems);
									}
								}
							}
						]
					}
				},
				{
					tag: 'div',
					style: 'float: right;',
					children:[
						{
							tag: 'dl-action-button',
							itemid: 'upload',
							'class': 'spacer-toolbar-item',					
							permissions: ['TRACTOR_MANAGEMENT:WRITE'],						
							children:[
								ElementUtil.makeIcon('vaadin:upload', 'Import')						
							],
							listeners: {
								click: function() {
									actionUpload();
								}
							}							
						}
					]
				}											
			]
		});		
		
		var toolbarContainer = ElementUtil.create({
			tag: 'div',
			slot: 'toolbar',
			children: [
				toolbarFilter,
				ElementUtil.create({
					tag: 'hr'
				}),
				toolbar
			]
		});			
	
		var grid = ElementUtil.create({
			tag: 'vaadin-grid',
			theme: 'wrap-cell-content row-stripes column-borders',
			'column-reordering-allowed': '',
			style: 'height: 100%;',			
			slot: 'primary',
			defaults: {
				tag: 'vaadin-grid-sort-column',
				resizable: true,
				listeners: {
					'direction-changed' : function(event) {
						if (event.detail && event.detail.value) {
							grid.currentSortField = event.target.path;
							grid.currentSortDirection = event.detail.value.toUpperCase();
							pagingToolbar.loadCurrentPage();
						}
					}
				}
			},			
			children: [
				{
					tag: 'vaadin-grid-selection-column',
					itemid: 'selectionColumn',
					'auto-select': true,
					'auto-width': true,
					listeners: {
						'select-all-changed': function() {
							gridSelectionChange();
						}
					}					
				},				
				{						
					path: 'tractorRefNo',
					header: 'Reference No',
					width: '7em'
				},	
				{						
					path: 'tractorVinNo',
					header: 'Vin',
					width: '7em'
				},			
				{						
					path: 'comment',
					header: 'Comment',
					width: '7em'
				},
				{						
					path: 'tags',
					header: 'Tags',
					width: '12em',
					renderer: function(root, column, rowData) {
						var tags = [];
						if (rowData.item.tags) {
							rowData.item.tags.forEach(function(tagItem) {
								tags.push(
									'<span class="tag-badge" style="margin: 3px;">' + tagItem + '</span>'
								);
							});
						}	
						
						root.innerHTML = tags.join('');
					}
				},
				{						
					path: 'tractorId',
					header: 'Tractor Id',
					width: '7em'
				}
			],
			listeners: {
				'active-item-changed': function(event) {
					const item = event.detail.value;					
				},
				'click': function(e) {
					gridSelectionChange();
				}
			}
		});	
			
		var gridSelectionChange = function() {
			setTimeout(function(){
				if (grid.selectedItems.length > 0) {
					if (grid.selectedItems.length === 1) {
						ElementUtil.query(toolbar, 'edit').disabled = false;
						ElementUtil.query(toolbar, 'tools').disabled = false;	
						ElementUtil.query(toolbar, 'details').disabled = false;	
						ElementUtil.query(toolbar, 'history').disabled = false;	
						ElementUtil.query(toolbar, 'references').disabled = false;
						
						ElementUtil.query(toolbar, 'juris').disabled = false;	
						ElementUtil.query(toolbar, 'ooa').disabled = false;	
						ElementUtil.query(toolbar, 'mpgoverride').disabled = false;	
						ElementUtil.query(toolbar, 'toggleStatus').disabled = false;	
						ElementUtil.query(toolbar, 'quickFlag').disabled = false;	
						
					} else {
						ElementUtil.query(toolbar, 'edit').disabled = true;
						ElementUtil.query(toolbar, 'details').disabled = true;
						ElementUtil.query(toolbar, 'history').disabled = true;	
						ElementUtil.query(toolbar, 'references').disabled = true;
						ElementUtil.query(toolbar, 'juris').disabled = true;	
						ElementUtil.query(toolbar, 'ooa').disabled = true;	
						ElementUtil.query(toolbar, 'mpgoverride').disabled = true;	
						ElementUtil.query(toolbar, 'toggleStatus').disabled = false;	
						ElementUtil.query(toolbar, 'quickFlag').disabled = false;
					}
				} else {						
					ElementUtil.query(toolbar, 'edit').disabled = true;
					ElementUtil.query(toolbar, 'tools').disabled = true;
					ElementUtil.query(toolbar, 'details').disabled = true;
					ElementUtil.query(toolbar, 'history').disabled = true;	
					ElementUtil.query(toolbar, 'references').disabled = true;
					ElementUtil.query(toolbar, 'juris').disabled = true;
					ElementUtil.query(toolbar, 'ooa').disabled = true;	
					ElementUtil.query(toolbar, 'mpgoverride').disabled = true;	
					ElementUtil.query(toolbar, 'toggleStatus').disabled = true;	
					ElementUtil.query(toolbar, 'quickFlag').disabled = true;
				}
			});
		};	
			
		var pagingToolbar = ElementUtil.create({
			tag: 'dl-paging-toolbar',
			slot: 'footer',
			pageSize: 50,
			postinit: function(element) {
				element.grid = grid;
				element.loader = function(backingGrid, pageNumber, pagingToolbar) {
					var pageRange = pagingToolbar.pullRange();
					var loadMask = grid.showLoading();
										
					var loadData = function() {
												
						grid.currentFilter = {
							offset: pageRange.offset,
							max: pageRange.max,
							sortField: backingGrid.currentSortField ? backingGrid.currentSortField : 'tractorRefNo',
							sortOrder: backingGrid.currentSortDirection	? backingGrid.currentSortDirection : 'ASC',							
							status: ElementUtil.query(toolbarFilter, 'status').value,
							filterField: ElementUtil.query(toolbarFilter, 'filterType').value,
							filterValue: ElementUtil.query(toolbarFilter, 'filterValue').value							
						};
																		
						var successHandler = function(records) {
							loadMask.remove();
							grid.activeItem = null;						
							grid.items = records.data;
							
							grid.selectedItems = [];
							gridSelectionChange();

							pagingToolbar.totalRecords = records.totalNumber;
							pagingToolbar.updatePager();						
						};
						
						UnitService.getTractorService().getTractors(grid.currentFilter).then(function(records){
							successHandler(records);
						});						
					};	
					
					loadData();
														
				};
			},
			listeners: {
				ready: function() {					
					pagingToolbar.loadCurrentPage();					
				}
			}
			
		});			
		
		var exportToolbar = ElementUtil.create({
			tag: 'dl-export-toolbar',			
			children: [				
			],
			listeners: {
				ready: function() {
					exportToolbar.updateGrid(grid);
				},
				'click-detail': function() {
					UnitService.getTractorService().exportTractors(grid.currentFilter);
				}
			}
		});
		
		var footerContainer = ElementUtil.create({
			tag: 'div',
			slot: 'footer',
			children: [
				exportToolbar,
				{
					tag: 'div',
					style: 'border-top: 1px solid lightgrey;'
				},
				pagingToolbar
			]
		});	
		var flexLayout = ElementUtil.create({
			tag: 'dl-flex-layout',
			children: [
				toolbarContainer,
				grid,
				footerContainer
			]
		});		
		tractorGrid.append(flexLayout);		
			
		var actionRefresh = function() {
			pagingToolbar.loadPage(1);	
		};

		tractorGrid.toolbarFilter = toolbarFilter;
		tractorGrid.pagingToolbar = pagingToolbar;
		attachWorkspaceFilterState(tractorGrid, toolbarFilter, ['filterType','filterValue','status'], actionRefresh);
				
		var actionAddEdit = function(record) {
			var addEditWin = ElementUtil.create({
				tag: 'dl-dialog',
				title: record ? 'Edit Tractor' : 'Add Tractor',
				icon: 'vaadin:edit',				
				width: .75,
				height: .75,
				listeners: {
					ready: function() {						
						addEditWin.show();
						
						var formPanel = ElementUtil.create({
							tag: 'dl-form-panel',
							itemid: 'form',
							children: [

								{
									tag: 'fieldset',
									children: [
										{
											tag: 'legend',
											innerHTML: 'Vehicle Description'
										},
										{
											tag: 'vaadin-form-layout',
											children: [
												{
													tag: 'vaadin-text-field',
													name: 'tractorRefNo',
													label: 'Reference No',
													required: true,
													maxLength: 80
												},
												{
													tag: 'vaadin-text-field',
													name: 'tractorVinNo',
													label: 'Vin',
													maxLength: 120
												},
												{
													tag: 'vaadin-combo-box',
													label: 'Equipment Ownership Type',
													name: 'equipmentOwnershipType',
													'item-value-path': 'code',
													'item-label-path': 'description',													
													value: 'CMPY',
													postinit: function (combo) {
														Service.getLookupService().getLookupValues('EquipmentOwnershipType').then(function (data) {
															combo.items = data;
															combo.required = true;
														});
													}
												},
												{
													tag: 'vaadin-combo-box',
													label: 'Make',
													name: 'tractorMake',
													'item-value-path': 'code',
													'item-label-path': 'description',
													postinit: function (combo) {
														Service.getLookupService().getLookupValues('TractorMake').then(function (data) {
															combo.items = data;
														});
													}
												},
												{
													tag: 'vaadin-number-field',
													name: 'tractorMfgYear',
													label: 'Manufacture Year',
													min: 1900,
													max: 2150
												},
												{
													tag: 'vaadin-number-field',
													name: 'gvwrEmptyAmt',
													label: 'GVWR Empty Amount',
													required: true,
													value: 15000,
													min: 0,
													max: 9999999
												},
												{
													tag: 'vaadin-number-field',
													name: 'gvwrAmount',
													label: 'GVWR Amount',
													required: true,
													value: 80000,
													min: 0,
													max: 9999999
												},
												{
													tag: 'vaadin-combo-box',
													label: 'Weight Units',
													name: 'weightUom',
													'item-value-path': 'code',
													'item-label-path': 'description',													
													value: 'LB',
													postinit: function (combo) {
														Service.getLookupService().getLookupValues('WeightUOM').then(function (data) {
															combo.items = data;
															combo.required = true;
														});
													}
												},
												{
													tag: 'vaadin-number-field',
													name: 'truckAxleCnt',
													label: 'Truck Axle Count',
													required: true,
													value: 3,
													min: 0,
													max: 9999
												},
												{
													tag: 'vaadin-number-field',
													name: 'maxAxleCnt',
													label: 'Max Axle Count',
													required: true,
													value: 5,
													min: 0,
													max: 9999
												},
												{
													tag: 'vaadin-checkbox',
													name: 'truckFlag',
													label: 'Truck'
												}
											]
										}
									]
								},
								{
									tag: 'fieldset',
									children: [
										{
											tag: 'legend',
											innerHTML: 'Licensing'
										},
										{
											tag: 'vaadin-form-layout',
											children: [
												{
													tag: 'vaadin-combo-box',
													itemid: 'licenseStateCB',
													label: 'License State/Province',
													name: 'licenseState',
													'item-value-path': 'code',
													'item-label-path': 'description',
													postinit: function (combo) {
														Service.getLookupService().getLookupValues('StateProvCode').then(function (data) {
															combo.items = data;
														});
													}
												},
												{
													tag: 'vaadin-text-field',
													name: 'licensePlateNo',
													label: 'License Plate',
													maxLength: 40
												},
												{
													tag: 'vaadin-text-field',
													name: 'licenseDecalNo',
													label: 'License Decal No / NY Permit No',
													maxLength: 40
												}
											]
										}
									]
								},
								{
									tag: 'fieldset',
									children: [
										{
											tag: 'legend',
											innerHTML: 'Operation'
										},
										{
											tag: 'vaadin-form-layout',
											children: [
												{
													tag: 'vaadin-combo-box',
													label: 'Driver',
													name: 'driverId',
													'item-value-path': 'code',
													'item-label-path': 'description',
													postinit: function (combo) {
														var paging = {
															max: 100
														};
														UnitService.getUnitLookupService().getUnits('DRIVER', paging).then(function (drivers) {
															combo.items = drivers.data;
														});
													},
													listeners: {
														input: {
															fn: function (e) {
																var paging = {
																	max: 100,
																	filterField: 'description',
																	filterValue: e.target.value
																};
																UnitService.getUnitLookupService().getUnits('DRIVER', paging).then(function (drivers) {
																	e.target.items = drivers.data;
																});
															},
															buffer: 2000
														}
													}
												},
												{
													tag: 'vaadin-combo-box',
													label: 'Team Driver',
													name: 'driverId',
													'item-value-path': 'code',
													'item-label-path': 'description',
													postinit: function (combo) {
														var paging = {
															max: 100
														};
														UnitService.getUnitLookupService().getUnits('DRIVER', paging).then(function (drivers) {
															combo.items = drivers.data;
														});
													},
													listeners: {
														input: {
															fn: function (e) {
																var paging = {
																	max: 100,
																	filterField: 'description',
																	filterValue: e.target.value
																};
																UnitService.getUnitLookupService().getUnits('DRIVER', paging).then(function (drivers) {
																	e.target.items = drivers.data;
																});
															},
															buffer: 2000
														}
													}
												},
												{
													tag: 'vaadin-combo-box',
													label: 'Haul Type',
													name: 'haulType',
													'item-value-path': 'code',
													'item-label-path': 'description',													
													value: 'FULL',
													postinit: function (combo) {
														Service.getLookupService().getLookupValues('HaulType').then(function (data) {
															combo.items = data;
															combo.required = true;
														});
													}
												}
											]
										}
									]
								},
								{
									tag: 'fieldset',
									children: [
										{
											tag: 'legend',
											innerHTML: 'Fuel Tax'
										},
										{
											tag: 'vaadin-form-layout',
											children: [
												{
													tag: 'vaadin-checkbox',
													name: 'fuelTaxExemptFlag',
													label: 'Fuel Tax (IFTA) Exempt'
												},												
												{
													tag: 'vaadin-checkbox',
													name: 'doNotUseTollMilesFlag',
													label: 'Do Not Use Toll Miles'
												}
											]
										}
									]
								},
								{
									tag: 'fieldset',
									children: [
										{
											tag: 'legend',
											innerHTML: 'Misc'
										},
										{
											tag: 'vaadin-form-layout',
											children: [
												{
													tag: 'vaadin-text-field',
													name: 'division',
													label: 'Division',
													maxLength: 255
												},
												{
													tag: 'vaadin-text-field',
													name: 'comment',
													label: 'Comment',
													maxLength: 255
												},
												{
													//wrap to make sure the layout works
													tag: 'div',
													children: [
														{
															tag: 'dl-tagfield',
															name: 'tags',
															label: 'Tags',
															maxLength: 80
														}
													]
												},
												{
													tag: 'dl-section-title',
													title: 'Tanks',
													colspan: 2,
													style: 'margin-top: 20px;'
												},
												{
													tag: 'div',
													style: 'height: 300px;',
													colspan: 2,
													children: [
														{
															tag: 'dl-flex-layout',
															children: [
																{
																	tag: 'dl-fueltank-grid',
																	itemid: 'tanksgrid',
																	slot: 'primary'
																}
															]
														}
													]
												}
											]
										}
									]
								},
								{
									tag: 'hr',
									colspan: 2
								},
								{
									tag: 'div',
									style: 'text-align: center;',
									colspan: 2,
									defaults: {
										tag: 'vaadin-button'
									},
									children: [
										{
											theme: 'primary',
											children: [
												ElementUtil.makeIcon('vaadin:database', ' Save')
											],
											listeners: {
												click: function () {

													//verify there is at least 1 tank
													var tanks =  ElementUtil.query(formPanel, 'tanksgrid').getTanks();
													if (tanks.length < 1) {
														window.DL.MessageUtil.showToastError('Must have at least 1 tank.');														
													} else {
														formPanel.submitForm({
															preSubmit: function (data) {
																data.tanks = tanks;
																
																var licenseStateItem = ElementUtil.query(formPanel, 'licenseStateCB').selectedItem;
																if (licenseStateItem) {
																	data.licenseCountry = licenseStateItem.country;
																} else {
																	delete data.licenseState;
																	delete data.licenseCountry;
																}
																
																if (data.tractorMake === '') {
																	delete data.tractorMake;
																}
																
																return data;
															},
															actualCall: function (data) {
																if (record) {
																	data.tractorId = record.tractorId;
																}
																return UnitService.getTractorService().saveTractor(data, (record ? true : false));
															},
															success: function (data, responseData) {
																window.DL.MessageUtil.showToast('Success', 'Saved Tractor', {
																	theme: 'success',
																	position: 'top-stretch'
																});
																actionRefresh();
																addEditWin.close();
															}
														});
													}	

												}
											}
										},
										{
											theme: 'tertiary',
											innerHTML: 'Cancel',
											style: 'margin-left: 10px;',
											listeners: {
												click: function () {
													//cancel
													addEditWin.close();
												}
											}
										}
									]
								}
							]
						});

						addEditWin.addToContentElement(formPanel);

						if (record) {
							formPanel.load(record);
							ElementUtil.query(formPanel, 'tanksgrid').updateTanks(record.tanks);
						} else {
							//default tank
							var tanks =[];
							tanks.push({
								fuelType: 'DSL',
								actual: false,
								tankCapacity: 125,
								quantityUOM: 'GALLON',
								tankId: 1								
							});
														
							ElementUtil.query(formPanel, 'tanksgrid').updateTanks(tanks);
						}
					}
				}
			});			
		};
		
		var actionUpload = function() {
			ImportUtil.showUpload({
				dataTypes: 'TRACTOR,OUT_OF_AUTHORITY,UNITS,TRACTOR_JURISDICTION,TRACTOR_MPG_OVERRIDE',
				visibleOptions: [
					'datafilterId',
					'dataTransformRuleSetId',
					'autoGroupId'
				],
				uploadUrl: '/api/resource/tractors/import'
			});
		};
		
		var actionDetails = function(record) {
			UnitTools.displayDetails({
				record: record,
				grid: grid,	
				allData: grid.items.slice(0),
				selectField: 'tractorId',
				getDetails: function(data){
					var detail = [
						{
							key: 'Vehicle Description',
							section: true,
							value: ''
						},
						{
							key: 'Tractor Id',
							value: data.tractorId
						},
						{
							key: 'Tractor Ref No',
							value: data.tractorRefNo
						},
						{
							key: 'Vin',
							value: data.tractorVinNo ? data.tractorVinNo : ''
						},
						{
							key: 'Ownership Type',
							value: data.equipmentOwnershipTypeDescription ? data.equipmentOwnershipTypeDescription : ''
						},
						{
							key: 'division',
							value: data.division ? data.division : ''
						},
						{
							key: 'Year',
							value: data.tractorMfgYear ? data.tractorMfgYear : ''
						},
						{
							key: 'Make',
							value: data.tractorMakeDescription ? data.tractorMakeDescription : ''
						},
						{
							key: 'GVWR Amount',
							value: data.gvwrAmount ? data.gvwrAmount : ''
						},	
						{
							key: 'GVWR Empty Amount',
							value: data.gvwrEmptyAmt ? data.gvwrEmptyAmt : ''
						},
						{
							key: 'Weight UOM',
							value: data.gvwrEmptyAmt ? data.gvwrEmptyAmt : ''
						},
						{
							key: 'Axles',
							value: data.truckAxleCnt
						},
						{
							key: 'Max Axles',
							value: data.maxAxleCnt
						},
						{	
							key: 'Truck Flag',
							value: data.truckFlag
						},
						{
							key: 'Deactivate Date',
							value: data.deactivateDts ? TimeUtil.formatDateStandard(data.deactivateDts) : "N/A"  
						},						
						{
							key: 'Comment',
							value: data.comment ? data.comment : ''
						},
						{	
							key: 'Update Date',
							value: TimeUtil.formatDateStandard(data.updateDts)
						},
						{	
							key: 'Update User',
							value: data.updateUser
						},
						{
							key: 'Licensing',
							section: true,
							value: ''
						},						
						{	
							key: 'Decail No',
							value: data.licenseDecalNo ? data.licenseDecalNo : ''
						},
						{	
							key: 'Plate No',
							value: data.licensePlateNo ? data.licensePlateNo : ''
						},
						{	
							key: 'State',
							value: data.licenseState ? data.licenseState : ''
						},
						{	
							key: 'Country',
							value: data.licenseCountry ? data.licenseCountry : ''
						},
						{	
							key: 'Expiration Date',
							value: data.licenseExpirationDate ? TimeUtil.formatDateStandard(data.licenseExpirationDate) : ''
						},
						{
							key: 'Operation',
							section: true,
							value: ''
						},
						{
							key: 'Driver',
							value: data.driverRefNo ? data.driverRefNo : ''
						},
						{
							key: 'Team Driver',
							value: data.teamDriverRefNo ? data.teamDriverRefNo : ''
						},
						{	
							key: 'Haul Type',
							value: data.haulTypeDescription
						},
						{
							key: 'Fuel Tax',
							section: true,
							value: ''
						},												
						{	
							key: 'Do Not Use Toll Miles Flag',
							value: data.doNotUseTollMilesFlag
						},
						{
							key: 'Fuel Tax Exempt Flag',
							value: data.fuelTaxExemptFlag
						}
					];
					UnitTools.insertV6EntityIdDetail(detail, data);
					
					if (data.tags) {
						detail.push({
							key: 'Tags',
							section: true,
							value: ''
						});
						data.tags.forEach(function(tag){
							detail.push({
								key: '',							
								value: tag
							});
						});
					}
					
					if (data.tankViews) {
						detail.push({
							key: 'Tank(s)',
							section: true,
							value: ''
						});
						data.tankViews.forEach(function(tank){
							detail.push({
								key: 'Tank Id',							
								value: tank.tankId
							});
							detail.push({
								key: 'Fuel Type',							
								value: tank.fuelTypDescription
							});
							detail.push({
								key: 'Tank Capacity',							
								value: tank.tankCapacity
							});
							detail.push({
								key: 'Quantity UOM',							
								value: tank.quantityUOM
							});
							detail.push({
								key: 'Actual',							
								value: tank.actual
							});
							detail.push({
								key: 'Average Tank Levels Ratio',							
								value: tank.aveTankLevelRatio ? tank.aveTankLevelRatio : ''
							});
						});
					}
					
					return detail;	
				}		
				
			});
		};
		
		var actionUpdateStatus = function(records) {
			
			if (records.length === 1) {
				var record = records[0];
				if (record.activeStatus === 'A') {
					UnitService.getTractorService().inactivateTractor(record.tractorId).then(function () {
						window.DL.MessageUtil.showToast('Success', 'Inactivated - ' + record.tractorRefNo);
						actionRefresh();
					});
				} else {
					UnitService.getTractorService().activateTractor(record.tractorId).then(function () {
						window.DL.MessageUtil.showToast('Success', 'Activated - ' + record.tractorRefNo);
						actionRefresh();
					});
				}
			} else {
				//confirm
				var multipleIds = {
					ids: []
				};
				records.forEach(function (record) {
					multipleIds.ids.push(
							record.dataLinkId
							);
				});
				var record = records[0];				
				window.DL.MessageUtil.showConfirm({
					title: 'Confirm Status Update',
					message: 'Are you sure you want to update status on the selected records?',
					buttons: [
						{
							text: 'Yes',
							handler: function () {
								var loadMask = grid.showLoading('Updating...');

								if (record.activeStatus === 'A') {
									UnitService.getTractorService().inactivateTractors(multipleIds)
											.then(function () {
												loadMask.remove();
												window.DL.MessageUtil.showToast('Success', 'Inactivated tractors', {
													theme: 'success'
												});
												actionRefresh();
											});
								} else {
									UnitService.getTractorService().activateTractors(multipleIds)
											.then(function () {
												loadMask.remove();
												window.DL.MessageUtil.showToast('Success', 'Activated tractors', {
													theme: 'success'
												});
												actionRefresh();
											});
								}
							}
						},
						{
							text: 'No'
						}
					]
				});
				
			}			
		};
		
		var actionMultiRefs = function(record) {
			UnitTools.multipleReferences({
				loadRefs: function(grid) {
					UnitService.getTractorService().getTractorMultiRefs(record.tractorId).then(function(data){
						grid.items = data;
					});
				},
				saveReference: function(data, edit) {
					data.tractorId = record.tractorId;
					return UnitService.getTractorService().saveTractorMultiRef(data, edit);
				},
				handleDelete: function(referenceId, successCallback) {
					UnitService.getTractorService().deleteTractorMultiRef(record.tractorId, referenceId).then(function(){
						successCallback();
					});
				}
			});
		};		
		
		var actionHistory = function(record) {			
			TractorTools.history({
				tractor: record
			});
		};
		
		var actionJurisdicitions = function(record) {
			TractorTools.jurisdictions({				
				tractor: record
			});
		};
		
		var actionOutOfAuthority = function(record) {
			TractorTools.outOfAuthority({
				tractor: record
			});
		};
		
		var actionMPGOverride = function(record) {
			TractorTools.mpgOverrides({
				tractor: record
			});
		};
		
		var actionQuickFlag = function(records) {
			TractorTools.quickFlag({
				tractors: records,
				successCallback: function() {
					actionRefresh();
				}	
			});
		};
		
	}
	
}
customElements.define('dl-tractor-grid', TractorGrid);
